var $f2e0410dbb606550$exports = {};
$f2e0410dbb606550$exports = {
    "help": `Ayuda`,
    "info": `Informaci\xf3n`
};


export {$f2e0410dbb606550$exports as default};
//# sourceMappingURL=es-ES.module.js.map
